'use strict';

const _ = require('lodash');
const moment = require('moment');

const satisfaction = {
    settings: (data) => {
        const value = _.parseInt(data.satisfaction);
        if (value === 0) {
            return 'remind on each encounter';
        } else if (value > 0) {
            return `remind after ${value} day(s) passed since the checkbox was checked on last time`;
        } else {
            return 'no reminder';
        }
    },
    warning: (data) => {
        const { status, satisfaction, satisfactionSurveyOffered, last } = data;
        if (status === 'active' && !satisfactionSurveyOffered) {
            if (!_.isNil(satisfaction)) {
                if (last) {
                    const days = moment().diff(moment(last), 'days');
                    if (satisfaction > 0) {
                        if (days >= satisfaction) {
                            return `${days} day(s) passed since a satisfaction survey was offered. Please offer a satisfaction survey.`;
                        }
                    } else {
                        return `${days} day(s) passed since a satisfaction survey was offered. Please offer a satisfaction survey.`;
                    }
                } else {
                    return 'Please offer a satisfaction survey.';
                }
            }
        }
        return null;
    }
};

module.exports = {
    satisfaction
};
